import { render, staticRenderFns } from "./DraftsSms.vue?vue&type=template&id=b9b87222&scoped=true&"
import script from "./DraftsSms.vue?vue&type=script&lang=js&"
export * from "./DraftsSms.vue?vue&type=script&lang=js&"
import style0 from "./DraftsSms.vue?vue&type=style&index=0&id=b9b87222&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9b87222",
  null
  
)

export default component.exports